module.exports = __webpack_public_path__ + "img/team_11.61468292.jpg";